module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"time":"h","spotsFree":"spot free | spots free","spotsFull":"sold out","expand":"Book","minPerTour":"Minimum persons per tour","addToCart":"Add to cart","bookVIP":"VIP experience","replace":{"title":"Replace tours","message":"You already selected experiences for another day. Do you want to replace these experiences?","replace":"Replace","keep":"Keep"}}}')
  delete Component.options._Ctor
}
